import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { CalViewParams } from '../cal-view.component';

@Component({
    selector: 'tt-cal-view-view',
    templateUrl: './cal-view-view.component.html',
    styleUrls: ['./cal-view-view.component.css'],
})
export class CalViewViewComponent {
    public params: CalViewParams;

    public heading = '';

    constructor(state: StateService) {
        this.params = state.getStateParams() as unknown as CalViewParams;
    }
}
